import NewTemplateDialog from './NewTemplateDialog';
import IconButton from '@/components/atoms/Button/IconButton';
import useDialog from '@/components/organisms/useDialog';

export default function NewTemplateButton({
  className = '',
  shouldShowIntroOutroWarningText = false,
  isIconOnly = false
}: {
  className?: string;
  shouldShowIntroOutroWarningText?: boolean;
  isIconOnly?: boolean;
}) {
  const { isOpen, openDialog, closeDialog } = useDialog();

  return (
    <>
      <IconButton
        icon="IconTemplate"
        buttonClassName={className}
        onClick={openDialog}
        content={isIconOnly ? undefined : 'Save as Template'}
        trackingId="add-brand-kit-template"
        title={isIconOnly ? 'Save as Template' : undefined}
      />
      <NewTemplateDialog
        isOpen={isOpen}
        closeDialog={closeDialog}
        shouldShowIntroOutroWarningText={shouldShowIntroOutroWarningText}
      />
    </>
  );
}
